import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
// Participant/Addresses/Get/{AuthToken}/{ParticipantGuid}/	
// Participant/Address/Create/{AuthToken}/{ParticipantGuid}/{ParticipantAddressTypeGuid}/{Priority}/{Address1}/{Address2}/{Address3}/{City}/{StateProvinceCounty}/{PostalCode}/{CountryCode}/
// Participant/Address/Update/{AuthToken}/{ParticipantAddressGuid}/{ParticipantAddressTypeGuid}/{Priority}/{Address1}/{Address2}/{Address3}/{City}/{StateProvinceCounty}/{PostalCode}/{CountryCode}/	
export const fetchParticipantAddresss = createAsyncThunk('participantaddress/get', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.get(PLATFORM + "Participant/Addresses/Get/" + incomingVariable.authToken + "/" + incomingVariable.ParticipantId_Guid + "/")
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const createParticipantAddresss = createAsyncThunk('participantaddress/create', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.post(PLATFORM
            + "Participant/Address/Create/"
            + incomingVariable.authToken + "/"
            + incomingVariable.ParticipantGuid + "/"
            + incomingVariable.ParticipantAddressTypeGuid + "/"
            + incomingVariable.Priority + "/"
            + incomingVariable.Address1 + "/"
            + incomingVariable.Address2 + "/"
            + incomingVariable.Address3 + "/"
            + incomingVariable.City + "/"
            + incomingVariable.StateProvinceCounty + "/"
            + incomingVariable.PostalCode + "/"
            + incomingVariable.CountryCode + "/"
        )
        const data = await response.data.Success ? response.data : [response.data]

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const updateParticipantAddresss = createAsyncThunk('participantaddress/update', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.post(PLATFORM
            + "Participant/Address/Update/"
            + incomingVariable.authToken + "/"
            + incomingVariable.ParticipantAddressGuid + "/"
            + incomingVariable.ParticipantAddressTypeGuid + "/"
            + incomingVariable.Priority + "/"
            + incomingVariable.Address1 + "/"
            + incomingVariable.Address2 + "/"
            + incomingVariable.Address3 + "/"
            + incomingVariable.City + "/"
            + incomingVariable.StateProvinceCounty + "/"
            + incomingVariable.PostalCode + "/"
            + incomingVariable.CountryCode + "/"
        )
        const data = await response.data.Success ? response.data : [response.data]

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const participantaddressSlice = createSlice({
    name: 'participantaddresss',
    initialState,
    reducers: {
        participantaddressClear(state, action) {
            state.entities = initialState.entities
            state.status="idle"
        }
        ,participantaddressUpdate(state, action) {
            const data= action.payload
            state.entities[data.ParticipantAddressGuid] = data
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchParticipantAddresss.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchParticipantAddresss.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if(Success===true){
                    state.error=null
                    state.status = 'success'
                    const loadedData = action.payload.Info
    
                    const data = {}
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        data[partObject.ParticipantAddressGuid] = partObject
                    }
                    state.entities = data
                }else{
                    state.status= 'failed'
                    state.error=action.payload.Status[0]
                }
            })
            .addCase(fetchParticipantAddresss.rejected, (state, action) => {
                state.error = action.error.message

            })
            .addCase(updateParticipantAddresss.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(updateParticipantAddresss.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if(Success===true){
                    state.error=null
                    state.status = 'success'
                    const loadedData = action.payload.Info
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        state.entities[partObject.ParticipantAddressGuid] = partObject
                    }
                }else{
                    state.status= 'failed'
                    state.error=action.payload.Status[0]
                }
            })
            .addCase(updateParticipantAddresss.rejected, (state, action) => {
                state.error = action.error.message
                state.status = "failed"
            })
            .addCase(createParticipantAddresss.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(createParticipantAddresss.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if(Success===true){
                    state.error=null
                    state.status = 'success'
                    const loadedData = action.payload.Info
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        state.entities[partObject.ParticipantAddressGuid] = partObject
                    }
                }else{
                    state.status= 'failed'
                    state.error=action.payload.Status[0]
                }
            })
            .addCase(createParticipantAddresss.rejected, (state, action) => {
                state.error = action.error.message
                state.status = "failed"
            })
    }
})

export const { participantaddressClear } = participantaddressSlice.actions

export default participantaddressSlice.reducer

const selectParticipantAddresssEntities = (state) => state.participantaddresss.entities

export const selectParticipantAddresss = createSelector(selectParticipantAddresssEntities, (entities) =>
    Object.values(entities)
)

export const selectParticipantAddresssById = (state, ParticipantAddresssId) => {
    return selectParticipantAddresssEntities(state)[ParticipantAddresssId]
}

export const selectParticipantAddresssByTypeGuid = createSelector(
    selectParticipantAddresss
    , (state, AddressTypeId_Guid) => AddressTypeId_Guid
    , (addresses, guid) => {
        //console.log('part add by type', {a:addresses, g:guid})
        return addresses.filter(address => {
            return address.ParticipantAddressTypeGuid && address.ParticipantAddressTypeGuid === guid
        })
    }

)